import { ProgressEventName } from './types';

export const PROGRESS_THRESHOLDS: Map<ProgressEventName, number> = new Map([
    ['firstQuartile', 0.25],
    ['midpoint', 0.5],
    ['thirdQuartile', 0.75],
    ['complete', 1],
]);

export const DEFAULT_TIMEOUT = 1000;
